import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "src/Components/Button/Button";
import CircularCheckbox from "src/SharedComponents/CircularCheckbox/CircularCheckbox";
import SmallDialog from "src/Components/Dialog/SmallDialog";

interface IPermanentUpgradeInfo {
    onClosePermanentUpgradeInfo: () => void;
    onConfirmPermanentUpgrade: () => void;
}

const PermanentUpgradeInfo: React.FC<IPermanentUpgradeInfo> = ({ onClosePermanentUpgradeInfo, onConfirmPermanentUpgrade }) => {
    const { t } = useTranslation();
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);
 useEffect(() => {
         if(isChecked)
        {
            setButtonDisabled(false);
        }
        else{
            setButtonDisabled(true);
        }
    }, [isChecked]);


    return (
        <>
        <SmallDialog
                    hideCancelButton = {true}
                    hideSubmitButton = {true}
                    title={t('ConvertingLicense')}
                    onClose={onClosePermanentUpgradeInfo}
                    onSubmit={() => {}}
                    width="475px">
                        <>
                       <div className="flex items-center justify-center min-h-screen bg-gray-100 mt-3">
                            <div className="bg-white rounded-2xl shadow-xl p-6 w-96 text-center">

                                <p className="text-sm text-gray-600 mb-4">
                                {t('LicenseConvertionTextWarningMessage')} <br />
                                <span className="font-semibold text-red-500">
                                    {t('ThisChangeIsIrreversible')}
                                </span>
                                </p>

                                <div className="flex items-center justify-center space-x-2 mb-6">
                                    <CircularCheckbox label={`${t('IAgree&Confirm')}`}
                                    onChecked={(isChecked) => setIsChecked(isChecked)} borderRadius="30%" isBold={false}/>
                                </div>
                    
                                <div className="mt-4">
                                     <Button
                                        text='Proceed'
                                        width='158px'
                                        disable={buttonDisabled}
                                        onClick={() => onConfirmPermanentUpgrade()}
                                    />
                                </div>
                            </div>
                        </div>
                        </>
                </SmallDialog>
        </>
    );
}

export default PermanentUpgradeInfo;